/**
 * Internal dependencies
 */
export type CreateFolderDatalayerProps = {
	recipeName: string;
	folderAmount: string;
	totalRecipeCount: string;
};

/**
 * Pushes an event to the data layer when a folder is created in Keittokirja.
 * This is used for analytics tracking.
 * @param {CreateFolderDatalayerProps} payload            - The payload containing folder details.
 * @param {string}                     payload.recipeName - The name of the recipe folder created.
 * @return {void}
 */
export function pushKeittokirjaCreateFolder({ recipeName, folderAmount, totalRecipeCount }: CreateFolderDatalayerProps): void {
	const isProduction = Boolean(window.valioAnalytics.isProduction);
	const datalayerObject = {
		event: 'keittokirja_create_folder',
		recipe_name: recipeName,
		folder_amount: folderAmount,
		total_recipe_count: totalRecipeCount,
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(datalayerObject);

	if (!isProduction) {
		// eslint-disable-next-line no-console
		console.log('🔍 DataLayer: keittokirja_create_folder', datalayerObject);
	}
}
